import React, { useEffect, useState } from 'react';
import { Box, Drawer, DrawerContent, DrawerOverlay, IconButton, Image, SimpleGrid, Text } from '@chakra-ui/react';
import { Close, ArrowBack, ArrowForward, ChevronRight } from '@mui/icons-material';

import Logo from './Logo';
import { categoryImage } from '../../hooks/useCatalog';
import { STORE, whatsappLink } from '../../config/store';

const Row = ({ children, onClick, href, chevron = true, color }) => (
    <Box
        as={href ? 'a' : 'button'} href={href} target={href ? '_blank' : undefined} rel={href ? 'noreferrer' : undefined}
        width='100%' display='flex' alignItems='center' justifyContent='space-between' py='14px'
        borderBottom='1px solid' borderColor='raano.border' fontSize='16px' color={color} textAlign='left' onClick={onClick}
    >
        {children}
        {chevron && <ChevronRight sx={{ fontSize: 20 }} />}
    </Box>
);

// Full-screen phone menu: a link list, and a "Shop" pane of category photo tiles (design-system.md §3.2)
const MenuDrawer = ({ isOpen, onClose, startInShop, categories, products, go, account }) => {

    const [pane, setPane] = useState('root');
    useEffect(() => { if (isOpen) setPane(startInShop ? 'shop' : 'root'); }, [isOpen, startInShop]);

    const paneAnim = { animation: 'paneIn .2s cubic-bezier(0.33, 1, 0.68, 1)', '@keyframes paneIn': { from: { transform: 'translateX(24px)', opacity: 0 }, to: { transform: 'none', opacity: 1 } } };

    return (
        <Drawer isOpen={isOpen} placement='left' onClose={onClose} size='full' >
            <DrawerOverlay />
            <DrawerContent>
                <Box display='flex' alignItems='center' height='60px' px='12px' gap='8px' borderBottom='1px solid' borderColor='raano.border' >
                    {pane === 'shop'
                        ? <IconButton variant='ghost' aria-label='Back' icon={<ArrowBack />} onClick={() => setPane('root')} />
                        : <IconButton variant='ghost' aria-label='Close menu' icon={<Close />} onClick={onClose} />}
                    <Logo size='24px' onClick={onClose} />
                </Box>

                {pane === 'root'
                    ? (
                        <Box key='root' px='16px' overflowY='auto' sx={paneAnim} >
                            <Row onClick={() => setPane('shop')} >Shop</Row>
                            <Row onClick={() => go('/search', {})} >New arrivals</Row>
                            <Row onClick={() => go('/favorites')} >Wishlist</Row>
                            {account.links.map(l => <Row key={l.path} onClick={() => go(l.path)} >{l.label}</Row>)}
                            <Row href={STORE.mapsUrl} >Store locator</Row>
                            <Row href={whatsappLink('Hi Raano!')} >WhatsApp us</Row>
                            {account.loggedIn
                                ? <Row chevron={false} color='raano.error' onClick={account.logout} >Log out</Row>
                                : <Row onClick={() => go('/login')} >Log in / Create account</Row>}
                        </Box>
                    )
                    : (
                        <Box key='shop' overflowY='auto' bg='raano.surface' flex={1} sx={paneAnim} >
                            <Text textAlign='center' fontSize='20px' fontWeight={700} py='16px' sx={{ fontStretch: '75%' }} >Shop Men</Text>
                            <SimpleGrid columns={3} spacing='6px' px='12px' >
                                {categories.map(c => (
                                    <Box key={c._id} as='button' position='relative' aspectRatio='0.88' overflow='hidden' bg='raano.imageBg' onClick={() => go('/search', { categoryId: c._id })} >
                                        {categoryImage(products, c._id) && <Image src={categoryImage(products, c._id)} alt='' width='100%' height='100%' objectFit='cover' objectPosition='top' />}
                                        <Box position='absolute' inset={0} bgGradient='linear(to-t, blackAlpha.600, transparent 50%)' />
                                        <Text position='absolute' bottom='6px' left='4px' right='4px' textAlign='center' color='raano.white' fontSize='11px' fontWeight={800} textTransform='uppercase' lineHeight={1.1} >{c.name}</Text>
                                    </Box>
                                ))}
                            </SimpleGrid>
                            <Box as='button' width='100%' display='flex' alignItems='center' justifyContent='space-between' px='16px' py='18px' fontSize='20px' fontWeight={700} sx={{ fontStretch: '75%' }} onClick={() => go('/search', {})} >
                                Shop All <ArrowForward />
                            </Box>
                        </Box>
                    )}
            </DrawerContent>
        </Drawer>
    );
};

export default MenuDrawer;
